import type { FaireProductEntity } from "../../entity_types/product";

export const p_r2uv6gx7yt: FaireProductEntity = {
  token: "p_r2uv6gx7yt",
  type: "product",
  name: "6\" x 9\" Poly Mailers - Pack of 100",
  brandToken: "b_ajaj2rm3ar",
  brandName: "Store Supply Warehouse",
  imageUrl: "https://cdn.faire.com/fastly/e83aa5b58b3925321fe9344e0f06f4542d91c7d2c4209b8098769ba7b06df5fe.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4a97a62eb0cb478d2c961025dee4152fac12d3c89c72453d9cbd4f41d800b0f6.jpeg",
    "https://cdn.faire.com/fastly/f9e0bf44de507e50c3c48b9e7ead281b7253b402f7744fb8e8b0f8403e2257b3.jpeg",
    "https://cdn.faire.com/fastly/efe0fc67705247b1af0c41f3ef695714d870a72989eb50a7def4e1b76d722640.jpeg",
    "https://cdn.faire.com/fastly/5725267860f69e42066aad0003fc956344ed6b2b73931077d108f46e952f6657.jpeg"
  ],
  priceDollars: 9.5,
  description: "Lightweight 6\" x 9\" poly mailers for shipping small, lightweight merchandise. The durable poly construction helps protect contents from moisture, dirt and everyday handling.\n\n- Size: 6\" x 9\"\n- Material: poly\n- Self-sealing adhesive closure for quick packing\n- Quantity: 100 mailers per pack\n\nWell suited to apparel, accessories and other small items from boutiques and online shops.",
  tags: [],
  msrpDollars: 14.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:18.412Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
